import { Endpoints } from "../constants/endpoint";
import axios from "axios";

export const GetAllCustomWords = async () => {
    try {
        const res = await fetch(Endpoints.customWords);
        console.log(res)
        if (!res.ok) {
            throw new Error(`HTTP error! status: ${res.status}`);
        }
        const data = await res.json();
        return data
    } catch (err) {
        return err.message;
    }
}

export const CreateCustomWord = async (payload) => {
    const options = {
        method: 'POST',
        headers: {
            'Accept': "application/json",
            'Content-Type': "application/json;charset=utf-8"
        },
        body: JSON.stringify(payload)
    };
    try {
        const res = await fetch(Endpoints.customWords, options);
        if (!res.ok) {
            throw new Error(`HTTP error! status: ${res.status}`);
        }
        const data = await res.json();
        return data
    } catch (err) {
        return err.message;
    }
}

export const EditCustomWord = async (payload, id) => {
    const options = {
        method: 'PUT',
        headers: {
            'Accept': "application/json",
            'Content-Type': "application/json;charset=utf-8"
        },
        body: JSON.stringify(payload)
    };
    try {
        const res = await fetch(Endpoints.customWords + id, options);
        if (!res.ok) {
            throw new Error(`HTTP error! status: ${res.status}`);
        }
        const data = await res.json();
        return data
    } catch (err) {
        return err.message;
    }
}

export const DeleteCustomWord = async (id) => {
    const options = {
        method: 'DELETE',
        headers: {
            'Accept': "application/json",
            'Content-Type': "application/json;charset=utf-8"
        }
    };
    try {
        const res = await fetch(Endpoints.customWords + id, options);
        if (!res.ok) {
            throw new Error(`HTTP error! status: ${res.status}`);
        }
        const data = await res.json();
        return data
    } catch (err) {
        return err.message;
    }
}


export const CreateCustomWords = async (payload) => {
    const options = {
        method: 'POST',
        headers: {
            'Accept': "application/json",
            'Content-Type': "application/json;charset=utf-8"
        },
        body: JSON.stringify(payload)
    };
    try {
        const res = await fetch(Endpoints.customWords, options);
        if (!res.ok) {
            throw new Error(`HTTP error! status: ${res.status}`);
        }
        const data = await res.json();
        return data
    } catch (err) {
        return err.message;
    }
}

export const CreateCustomWordsBulk = async (payload) => {
    const options = {
        method: 'POST',
        headers: {
            'Accept': "application/json",
            'Content-Type': "application/json;charset=utf-8"
        },
        body: JSON.stringify(payload)
    };
    try {
        const res = await fetch(Endpoints.customWords + "bulk", options);
        if (!res.ok) {
            throw new Error(`HTTP error! status: ${res.status}`);
        }
        const data = await res.json();
        return data
    } catch (err) {
        return err.message;
    }
}

export const EditCustomWords = async (payload, params) => {
    const options = {
        method: 'PUT',
        headers: {
            'Accept': "application/json",
            'Content-Type': "application/json;charset=utf-8"
        },
        body: JSON.stringify(payload)
    };
    try {
        const res = await fetch(Endpoints.customWords + params, options);
        if (!res.ok) {
            throw new Error(`HTTP error! status: ${res.status}`);
        }
        const data = await res.json();
        return data
    } catch (err) {
        return err.message;
    }
}


export const GetFullCustomWordById = async (id) => {
    try {
      const res = await fetch(Endpoints.customWords + id + "/full");
      if (!res.ok) {
        throw new Error(`HTTP error! status: ${res.status}`);
      }
      const data = await res.json();
      return data;
    } catch (err) {
      return err.message;
    }
  };
  
  export const GetGroupedCustomWords = async () => {
    try {
      const res = await axios.get(`${Endpoints.customWords}grouped`);
      return res.data;
    } catch (err) {
      return err.message;
    }
  };

  export const SaveCustomWordsBulk = async (payload) => {
    try {
      const res = await axios.post(`${Endpoints.customWords}bulk`, payload);
      return res.data;
    } catch (err) {
      return err.message;
    }
  };
  